module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "user-verification-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("用户验证信息")]), _vm._v(" "), _c('div', {
    staticClass: "selectSchool"
  }, [_c('el-select', {
    staticClass: "selectInput",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入高校名称"
    },
    on: {
      "change": _vm.changeSchool
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }, _vm._l((_vm.schoolOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importuserinfo),
      expression: "importuserinfo"
    }],
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickFaceRecord
    }
  }, [_vm._v("人脸导入记录")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importuserinfo),
      expression: "importuserinfo"
    }],
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickFaceImport
    }
  }, [_vm._v("导入人脸")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportModel
    }
  }, [_vm._v("导出模板")]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importuserinfo),
      expression: "importuserinfo"
    }],
    staticClass: "right_f",
    attrs: {
      "with-credentials": true,
      "action": _vm.importverification,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "name": "uploadFile"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("导入用户信息文件")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowuserData),
      expression: "isshowuserData"
    }],
    staticClass: "form-bezel"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册状态:"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.registerStatus),
      callback: function($$v) {
        _vm.registerStatus = $$v
      },
      expression: "registerStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已注册",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未注册",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "建模状态:"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.faceStatus),
      callback: function($$v) {
        _vm.faceStatus = $$v
      },
      expression: "faceStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "成功",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "失败",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-input', {
    staticClass: "name-input",
    attrs: {
      "placeholder": "请输入学生姓名或学号"
    },
    model: {
      value: (_vm.searchName),
      callback: function($$v) {
        _vm.searchName = $$v
      },
      expression: "searchName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "searchBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryUserList
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "button-export",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickExportTable
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userData.length > 0),
      expression: "userData.length > 0"
    }],
    attrs: {
      "data": _vm.userData
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学号/教职工号",
      "prop": "stuId",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "姓名",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "院系",
      "prop": "className"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "性别",
      "prop": "gender"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "班级",
      "prop": "gradeClass"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "年级",
      "prop": "grade"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "注册状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n                    " + _vm._s(row.uid ? '已注册' : '未注册') + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "人脸图",
      "prop": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (row.status === 1),
            expression: "row.status === 1"
          }],
          staticClass: "face-image",
          attrs: {
            "src": row.faceUrl,
            "alt": ""
          }
        }), _vm._v(" "), _c('el-popover', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (row.status === 2),
            expression: "row.status === 2"
          }],
          attrs: {
            "placement": "top",
            "visible-arrow": false,
            "trigger": "hover"
          }
        }, [_c('div', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("失败")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(row.incorrectReason))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "建模状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('ModelPopover', {
          attrs: {
            "data-source": row.modelStatusList
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDeleteFace(row)
            }
          }
        }, [_vm._v("删除人脸")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEdit(row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "page-count": _vm.pageCount,
      "total": _vm.total,
      "current-page": _vm.currentPage
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户验证信息编辑",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.editDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "visible", $$v)
      },
      expression: "editDialog.visible"
    }
  }, [_c('el-form', {
    staticClass: "edit-form",
    attrs: {
      "label-width": "120px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学号/教职工号："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入学号/教职工号",
      "disabled": true
    },
    model: {
      value: (_vm.editForm.stuId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "stuId", $$v)
      },
      expression: "editForm.stuId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('label', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    姓               名：\n                ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('label', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    性               别：\n                ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择性别"
    },
    model: {
      value: (_vm.editForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "gender", $$v)
      },
      expression: "editForm.gender"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "男",
      "value": "男"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "女",
      "value": "女"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('label', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    院               系：\n                ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择院系"
    },
    on: {
      "change": _vm.changeDepartment
    },
    model: {
      value: (_vm.editForm.className),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "className", $$v)
      },
      expression: "editForm.className"
    }
  }, _vm._l((_vm.editDialog.departmentOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.department,
        "value": item.department
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDialog.classOptions.length > 0),
      expression: "editDialog.classOptions.length > 0"
    }]
  }, [_c('label', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    班               级：\n                ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择班级"
    },
    model: {
      value: (_vm.editForm.gradeClass),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "gradeClass", $$v)
      },
      expression: "editForm.gradeClass"
    }
  }, _vm._l((_vm.editDialog.classOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('label', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    年               级：\n                ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择年级"
    },
    model: {
      value: (_vm.editForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "grade", $$v)
      },
      expression: "editForm.grade"
    }
  }, _vm._l((_vm.editDialog.editYearOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickEditDone
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips-content"
  }, [_c('p', [_vm._v("提示：")]), _vm._v(" "), _c('p', [_vm._v("1.仅添加用户验证信息，用于身份验证，不会创建用户账号。2.若学号/工号相同，新增记录将覆盖原有记录")]), _vm._v(" "), _c('p', [_vm._v("2.只有弹出导入成功文案提示才是导入成功，100%状态的时候是在等待中，如果太久没有导入成功，请刷新页面重新导入")]), _vm._v(" "), _c('p', [_vm._v("3.每次模板导入数据请不要超过3000条。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94bd735a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserManage/UserManage/UserVerification.vue
// module id = 1104
// module chunks = 0